export default __webpack_public_path__ + "static/media/check.dae22000.png";